import React, { Component } from 'react';
import { debounce } from 'lodash';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as EventsActions, Selectors as EventsSelectors } from 'store/ducks/events';

import { Form } from 'components';

class Filters extends Component {
  state = {
    cpf: '',
    status: [{ value: '', label: 'todos' }, { value: 0, label: 'ausentes' }, { value: 1, label: 'presentes' }],
    amounts: [{ value: 25, label: '25' }, { value: 50, label: '50' }, { value: 75, label: '75' }],
  };

  constructor(props) {
    super(props);

    const { onChange } = props;

    this.handleChange = debounce(onChange, 300);
  }

  handleChangeCpf = value => {
    this.setState({ cpf: value });
    this.handleChange('cpf', value);
  };

  render() {
    const { cpf, status, amounts } = this.state;
    const { data, onChange } = this.props;

    return (
      <Form className="row hide-on-print">
        <Form.Field className="col-md-2">
          <Form.Label>CPF</Form.Label>
          <Form.Input
            name="cpf"
            placeholder="CPF"
            mask="cpf"
            value={cpf}
            onChange={value => this.handleChangeCpf(value)}
          />
        </Form.Field>

        <Form.Field className="col-md-2">
          <Form.Label>Situação</Form.Label>
          <Form.Select options={status} value={data.status} onChange={value => onChange('status', value)} />
        </Form.Field>

        <Form.Field className="col-md-2">
          <Form.Label>Clientes por Página</Form.Label>
          <Form.Select options={amounts} value={data.per} onChange={value => onChange('per', value)} />
        </Form.Field>
      </Form>
    );
  }
}

const mapState = state => ({
  stores: {
    ...state.events.stores,
    data: EventsSelectors.stores(state.events.stores.data),
  },
});

const mapActions = dispatch => bindActionCreators(EventsActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(Filters);
